var map = {
	"./comment": 3,
	"./comment.png": 3,
	"./exclamation_mark": 4,
	"./exclamation_mark.png": 4,
	"./plus": 5,
	"./plus.png": 5,
	"./trash_can": 6,
	"./trash_can.png": 6
};


function webpackContext(req) {
	var id = webpackContextResolve(req);
	return __webpack_require__(id);
}
function webpackContextResolve(req) {
	if(!__webpack_require__.o(map, req)) {
		var e = new Error("Cannot find module '" + req + "'");
		e.code = 'MODULE_NOT_FOUND';
		throw e;
	}
	return map[req];
}
webpackContext.keys = function webpackContextKeys() {
	return Object.keys(map);
};
webpackContext.resolve = webpackContextResolve;
module.exports = webpackContext;
webpackContext.id = 17;